import React, { useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  GET_PONENCIA_ID,
  GET_PONENCIAS,
  SEARCH_PONENCIAS,
  REMOVE_PONENCIA,
} from '../../graphql/actions/ponencia';
import axios from 'axios';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import SaveAlt from '@material-ui/icons/SaveAlt';
import Delete from '@material-ui/icons/Delete';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Card from '../../components/UI/Card/Card';
import CardBody from '../../components/UI/Card/CardBody';
import Button from '../../components/UI/CustomButtons/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
import Order from '../Order/Order';
import Filter from '../Filter/Filter';
import Limit from '../Limit/Limit';
import Paginate from '../Paginate/Paginate';
import Total from '../Total/Total';
import ButtonAdd from '../ButtonAdd/ButtonAdd';
import PonenciaDel from './PonenciaDel';

import sectionDataStyle from '../../assets/jss/coscef/views/ponenciaSections/sectionDataStyle';

const url =
  process.env.NODE_ENV === 'development'
    ? 'http://100.100.100.248:4000/'
    : 'https://api.coscef.nat.cu/';

const useStyles = makeStyles(sectionDataStyle);

const PonenciaData = (props) => {
  const classes = useStyles();
  const [numPonencias, setNumPonencias] = useState(9);
  const [field, setField] = useState('createdAt');
  const [order, setOrder] = useState('ASC');
  const [search, setSearch] = useState('');
  const [eliminarPonenciaModal, setEliminarPonenciaModal] = useState(false);

  const eliminarShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_PONENCIA_ID,
      data: { getPonenciaId: id },
    });
    setEliminarPonenciaModal(true);
  };

  const eliminarCloseModalHandler = () => {
    setEliminarPonenciaModal(false);
  };

  const closeModalHandler = (data) => {
    //console.log(data);
    if (data.removePonencia) setEliminarPonenciaModal(false);
    else console.log('Error eliminando ponencia.');
  };

  const updateCacheDel = (cache, id) => {
    const { getPonencias } = cache.readQuery({
      query: GET_PONENCIAS,
      variables: {
        paginate: {
          numPonencias: numPonencias,
          cursor: '',
          sortBy: { field: field, order: order },
        },
      },
    });

    const nuevoPonencias = getPonencias.ponencias.filter(
      (ponencia) => ponencia.id !== id
    );

    if (getPonencias && nuevoPonencias) {
      cache.writeQuery({
        query: GET_PONENCIAS,
        variables: {
          paginate: {
            numPonencias: numPonencias,
            cursor: '',
            sortBy: { field: field, order: order },
          },
        },
        data: {
          getPonencias: {
            ponencias: nuevoPonencias,
          },
        },
      });
    }
  };

  const {
    loading: loadingPonencias,
    error: errorPonencias,
    data: dataPonencias,
    fetchMore,
  } = useQuery(GET_PONENCIAS, {
    variables: {
      paginate: {
        numPonencias: numPonencias,
        cursor: '',
        sortBy: { field: field, order: order },
      },
    },
    errorPolicy: 'all',
  });

  const [executeSearch, { loading: loadingSearch, data: dataSearch }] =
    useLazyQuery(SEARCH_PONENCIAS, {
      errorPolicy: 'all',
    });

  const [
    eliminarPonencia,
    { loading: loadingRemove, error: errorRemove, data: dataRemove },
  ] = useMutation(REMOVE_PONENCIA, {
    errorPolicy: 'all',
    update: updateCacheDel,
    onCompleted: (data) => closeModalHandler(data),
  });

  const onDownloadFileHandler = async (e, id, fichero) => {
    e.preventDefault();
    let filename;
    if (fichero) {
      const arrayString = fichero.split('/');
      //console.log(arrayString[arrayString.length - 1]);
      filename = arrayString[arrayString.length - 1];
    }
    if (id) {
      try {
        const config = {
          responseType: 'blob', // important
          headers: {
            //'Content-Type': 'application/pdf',
            //'Content-Type': 'application/msword',
            //'Content-Type':
            //  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            //'Content-Type': 'application/vnd.ms-powerpoint',
            //'Content-Disposition': 'attachment',
            //Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };
        const response = await axios.get(
          url + 'api/file/ponencia/' + id,
          config
        );

        if (response.data) {
          //console.log(response.data);
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers['Content-Type'],
            })
          );
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', filename); //any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      } catch (error) {
        console.log(error.response.data);
      }
    }
  };

  const onSearchHandler = (event) => {
    event.preventDefault();
    executeSearch({
      variables: {
        paginate: {
          numPonencias: numPonencias,
          cursor: '',
          query: search,
          sortBy: { field: field, order: order },
        },
      },
    });
  };

  const removePonenciaHandler = (id) => {
    eliminarPonencia({
      variables: {
        input: {
          id: id,
        },
      },
    });
  };

  const numPonenciasChangedHandler = (event) => {
    if (event.target.name === 'numComponentes')
      setNumPonencias(event.target.value);
  };

  const fieldChangedHandler = (event) => {
    if (event.target.name === 'field') setField(event.target.value);
  };

  const orderChangedHandler = (event) => {
    if (event.target.name === 'order') setOrder(event.target.value);
  };

  const searchChangedHandler = (event) => {
    if (event.target.name === 'search') setSearch(event.target.value);
  };

  const onPaginationHandler = (cursor) => {
    fetchMore({
      variables: {
        paginate: {
          numPonencias: numPonencias,
          cursor: cursor,
          sortBy: { field: field, order: order },
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        fetchMoreResult.getPonencias.ponencias = [
          ...prev.getPonencias.ponencias,
          ...fetchMoreResult.getPonencias.ponencias,
        ];
        return fetchMoreResult;
      },
    });
  };

  let showNotification = null;
  let seccionTitulo = null;
  let seccionOrderFilter = null;
  let seccionCardPonencia = null;
  let seccionBotonAdd = null;
  let seccionLimitPagination = null;
  let seccionTotal = null;
  let removeModal = (
    <PonenciaDel
      show={eliminarPonenciaModal}
      close={eliminarCloseModalHandler}
      removePonencia={removePonenciaHandler}
    />
  );

  if (loadingPonencias) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (loadingRemove) removeModal = <Spinner color='gray' />;
  if (loadingSearch) {
    seccionOrderFilter = (
      <div id='orderandfilter' className={classes.marginBottom20}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <Order />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorPonencias) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>
              Error al buscar las ponencias en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionOrderFilter = null;
    seccionCardPonencia = null;
    seccionBotonAdd = null;
    seccionLimitPagination = null;
    seccionTotal = null;

    showNotification = errorPonencias.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorPonencias ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorRemove) {
    showNotification = errorRemove.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorRemove ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataPonencias && dataPonencias.getPonencias) {
    const { getPonencias } = dataPonencias;
    //console.log(getPonencias);
    if (getPonencias.ponencias.length === 0) {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron ponencias, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = null;
      seccionCardPonencia = null;

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'ponencia'} />
        </div>
      ) : null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>Ponencias</h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'ponencia'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardPonencia = (
        <GridContainer>
          {getPonencias.ponencias.map((ponencia) => (
            <GridItem xs={12} sm={4} md={4} key={ponencia.node._id}>
              <Card color='dark' key={ponencia.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {ponencia.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {ponencia.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        color='white'
                        round
                        justIcon
                        onClick={(e) =>
                          onDownloadFileHandler(
                            e,
                            ponencia.node._id,
                            ponencia.node.fichero
                          )
                        }
                      >
                        <SaveAlt className={classes.icons} />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-ponencia/' + ponencia.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(ponencia.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) =>
                          onDownloadFileHandler(
                            e,
                            ponencia.node._id,
                            ponencia.node.fichero
                          )
                        }
                      >
                        <SaveAlt className={classes.icons} /> Descargar Ponencia
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'ponencia'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numPonencias}
                numdComponentesChange={numPonenciasChangedHandler}
                nombreComponente={'Ponencias'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={getPonencias.pageInfo.startCursor}
                cursorFinal={getPonencias.pageInfo.endCursor}
                tienePaginaSiguiente={getPonencias.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={getPonencias.totalCount}
            nombreComponente={'Ponencias'}
          />
        </div>
      );
    }
  }

  if (dataSearch && dataSearch.searchPonencias) {
    const { searchPonencias } = dataSearch;

    if (searchPonencias.ponencias.length === 0) {
      seccionTitulo = null;

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}></GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'ponencia'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardPonencia = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron ponencias en la busqueda.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionBotonAdd = null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'ponencia'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardPonencia = (
        <GridContainer>
          {searchPonencias.ponencias.map((ponencia) => (
            <GridItem xs={12} sm={4} md={4} key={ponencia.node._id}>
              <Card color='dark' key={ponencia.node._id}>
                <CardBody color>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {ponencia.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {ponencia.node.resumen + ' ...'}
                  </p>
                  {props.isAuth ? (
                    <div className={classes.textCenter}>
                      <Button
                        color='white'
                        round
                        justIcon
                        onClick={(e) =>
                          onDownloadFileHandler(
                            e,
                            ponencia.node._id,
                            ponencia.node.fichero
                          )
                        }
                      >
                        <SaveAlt className={classes.icons} />
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(
                            '/editar-ponencia/' + ponencia.node._id
                          );
                        }}
                      >
                        <Icon>mode_edit</Icon>
                      </Button>
                      <Button
                        round
                        justIcon
                        color='white'
                        onClick={() =>
                          eliminarShowModalHandler(ponencia.node._id)
                        }
                      >
                        <Delete />
                      </Button>
                    </div>
                  ) : (
                    <div
                      className={
                        classes.stats + ' ' + classes.justifyContentCenter
                      }
                    >
                      <Button
                        color='white'
                        round
                        onClick={(e) =>
                          onDownloadFileHandler(
                            e,
                            ponencia.node._id,
                            ponencia.node.fichero
                          )
                        }
                      >
                        <SaveAlt className={classes.icons} /> Descargar Ponencia
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'ponencia'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numPonencias}
                numdComponentesChange={numPonenciasChangedHandler}
                nombreComponente={'Ponencias'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={searchPonencias.pageInfo.startCursor}
                cursorFinal={searchPonencias.pageInfo.endCursor}
                tienePaginaSiguiente={searchPonencias.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={searchPonencias.totalCount}
            nombreComponente={'Ponencias'}
          />
        </div>
      );
    }
  }

  if (dataRemove && dataRemove.removePonencia) {
    const { removePonencia } = dataRemove;
    if (removePonencia.success && removePonencia.code === '200') {
      showNotification = (
        <Notification
          key={removePonencia.code}
          mostrar={removePonencia.success ? true : false}
          msg={removePonencia.message}
          stt={removePonencia.success}
        />
      );
    }
  }

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            {seccionTitulo}
            <div className={classes.marginTop35}>
              {removeModal}
              {seccionOrderFilter}
              {seccionCardPonencia}
              {seccionBotonAdd}
              {seccionLimitPagination}
              {seccionTotal}
            </div>
          </div>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default withRouter(PonenciaData);
